import { render } from "./TransitionContainer.vue?vue&type=template&id=2533819e"
import script from "./TransitionContainer.vue?vue&type=script&lang=js"
export * from "./TransitionContainer.vue?vue&type=script&lang=js"

import "./TransitionContainer.vue?vue&type=style&index=0&id=2533819e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__